// extracted by mini-css-extract-plugin
export var imageWrapper = "styles-module--imageWrapper--9a348";
export var title = "styles-module--title--3a3d7";
export var wrapper = "styles-module--wrapper--677c6";